module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#details1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES37UC3']['10']) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "details1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "coddesc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.detail.codempid) + " - " + _vm._s(_vm.detail.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dtereq",
      "name": "dtereq"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.dtereq)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC1']['35']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "numseq",
      "name": "numseq"
    }
  }, [_vm._v(_vm._s(_vm.detail.numseq))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70 txtarea-width response-full-width",
    attrs: {
      "id": "desnote",
      "name": "desnote"
    }
  }, [_vm._v(_vm._s(_vm.detail.desnote))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "dteuse",
      "name": "dteuse"
    }
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.detail.dteuse)))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flginc),
      expression: "detail.flginc"
    }],
    attrs: {
      "type": "radio",
      "name": "flginc1",
      "value": "Y",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flginc, "Y")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flginc", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['70']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.flginc),
      expression: "detail.flginc"
    }],
    attrs: {
      "type": "radio",
      "name": "flginc2",
      "value": "N",
      "disabled": "disabled"
    },
    domProps: {
      "checked": _vm._q(_vm.detail.flginc, "N")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.detail, "flginc", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio-text"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['80']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES37UC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "typcer",
      "name": "typcer"
    }
  }, [_vm._v(_vm._s(_vm.detail.typcer))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94c3f784!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres37u/detail.vue
// module id = 3926
// module chunks = 1